<!--<div id="content" class="mb-0">-->
<section class="content">
  @if (page?.banner_image) {
    <img src="{{page.banner_image}}" alt="{{page.page_title}}">
  }
  @if (!loading) {
    <div class="panel">
      @if (page.show_title) {
        <h1 class="title">{{page.page_title}}</h1>
      }
      <app-page-content [body]="body" [public]="page.public"></app-page-content>
    </div>
  }
</section>

<!--</div>-->
